module.exports = __webpack_public_path__ + "img/game-feature5.20276c44.png";